import { render, staticRenderFns } from "./ReleaseTrackEdit.vue?vue&type=template&id=219ae70c&scoped=true&"
import script from "./ReleaseTrackEdit.vue?vue&type=script&lang=js&"
export * from "./ReleaseTrackEdit.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseTrackEdit.vue?vue&type=style&index=0&id=219ae70c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ae70c",
  null
  
)

export default component.exports